import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueSweetalert2 from 'vue-sweetalert2';
import VueMask from 'v-mask'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueYoutube from 'vue-youtube'
import dayjs from 'dayjs';
import vco from "v-click-outside"

// import '@/assets/jlFonts/iconfont.css';

import router from './router'
import store from '@/state/store'
import i18n from './i18n'

import BMap from "vue-baidu-map";

import "@/assets/scss/app.scss";

import { initFirebaseBackend } from './helpers/firebase/authUtils';

import { configureFakeBackend } from './helpers/fakebackend/fake-backend';
import copyrightConfig from "@/utils/config/changeCopyright.js";


import VueCropper from 'vue-cropper'

// 动态设置 TDK 和统计代码
const appid = copyrightConfig.AppID;
console.log(appid,'appid')

// 动态加载统计代码
function loadAnalytics(id, ck) {
  const existingScript = document.getElementById('LA_COLLECT');
  if (existingScript) existingScript.remove();

  const script = document.createElement('script');
  script.charset = 'UTF-8';
  script.id = 'LA_COLLECT';
  script.src = '//sdk.51.la/js-sdk-pro.min.js';
  script.onload = () => window.LA && window.LA.init({id, ck});
  document.head.appendChild(script);
}

if (appid === 'wx1e899bddb256a5ca') {
  document.title = '接龙加加-微信群小程序工具,学校班级报名打卡签到统计投票平台';
  document.querySelector('meta[name="keywords"]').setAttribute('content', '信息收集工具、活动报名小程序、打卡签到');
  document.querySelector('meta[name="description"]').setAttribute('content', '接龙加加是一款免费高效的信息收集与管理小程序，支持活动报名、打卡签到、问卷统计、文件签字等全场景需求。覆盖教育、企业、社群等多领域，提供海量模板与智能统计功能，助力组织者1分钟快速创建接龙，高效管理数据。');
  const link = document.querySelector("link[rel~='icon']");
  if (link) link.href = '/favicon-jl.ico'
  // 加载接龙加加的统计代码
  loadAnalytics('JVQmWocuEvTrHNQh', 'JVQmWocuEvTrHNQh');
} else if (appid === 'wx7d8daf6d777947a2') {
  document.title = '报名管家-微信接龙小程序,学校班级群打卡签到统计投票工具';
  console.log('报名管家title')
  const link = document.querySelector("link[rel~='icon']");
  if (link) link.href = '/favicon-bm.ico'
  document.querySelector('meta[name="keywords"]').setAttribute('content', '微信接龙、活动报名、签到管理、小程序工具');
  document.querySelector('meta[name="description"]').setAttribute('content', '报名管家是一款免费的活动报名接龙管理小程序，支持快速创建报名表单、实时统计数据、打卡定位签到等功能，适用于学校、企业、社群等多场景，助力教师，企业行政等组织者高效管理活动数据。');
  loadAnalytics('JUyQAqcGva7eZUaf', 'JUyQAqcGva7eZUaf');
} else {
  document.title = '接龙加加-微信群小程序工具,学校班级报名打卡签到统计投票平台';
  const link = document.querySelector("link[rel~='icon']");
  if (link) link.href = '/favicon-jl.ico'
  document.querySelector('meta[name="keywords"]').setAttribute('content', '信息收集工具、活动报名小程序、打卡签到');
  document.querySelector('meta[name="description"]').setAttribute('content', '接龙加加是一款免费高效的信息收集与管理小程序，支持活动报名、打卡签到、问卷统计、文件签字等全场景需求。覆盖教育、企业、社群等多领域，提供海量模板与智能统计功能，助力组织者1分钟快速创建接龙，高效管理数据。');
  // 默认加载接龙加加的统计代码
  loadAnalytics('JVQmWocuEvTrHNQh', 'JVQmWocuEvTrHNQh');
}

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueYoutube)
Vue.use(BootstrapVue)
Vue.use(vco)
Vue.use(Vuelidate)
Vue.use(VueSweetalert2);
Vue.use(VueMask)
Vue.use(VueCropper)
Vue.use(require('vue-chartist'))
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.use(BMap, {ak: 'byF65LF4eoVPkNAx72P9dLbMPq4QswaI'})
Vue.prototype.$dayjs = dayjs;
Vue.component('apexchart', VueApexCharts)

Vue.directive('removeAriaHidden', {
    bind(el) {
        let ariaEls = el.querySelectorAll('.el-radio__original');
        ariaEls.forEach((item) => {
            item.removeAttribute('aria-hidden');
        });
    }
});


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
